import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=3c06ee4e&scoped=true&"
import script from "./LoginNew.vue?vue&type=script&lang=ts&"
export * from "./LoginNew.vue?vue&type=script&lang=ts&"
import style0 from "./LoginNew.vue?vue&type=style&index=0&id=3c06ee4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06ee4e",
  null
  
)

export default component.exports